module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj = {}, _obj[_vm.settingsLinkActiveClass] = (_vm.settingLink == 'Logs'), _obj ),
    attrs: {
      "to": {
        name: 'Logs'
      }
    }
  }, [_c('span', [_vm._v("История")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-254011c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/logs/menus/SettingsMenu.vue
// module id = 1072
// module chunks = 0